import React from 'react'
import { Link } from 'react-router-dom'

function PrivacyPage() {
  return (
    <div className="app">
      <div id="stars"></div>
      <div className="wrapper privacy-wrapper">
        <header className="privacy-header">
          <h1>萝卜水印相机隐私政策</h1>
          <p className="privacy-subtitle">Privacy Policy</p>
          <p className="agreement-date">更新日期：2026年10月14日</p>
          <p className="agreement-date">生效日期：2026年10月14日</p>
        </header>

        <main className="privacy-content">
          <section className="privacy-section">
            <h2>引言</h2>
            <p>
              萝卜水印相机（以下简称“本应用”）由彭洋（联系方式：
              <a href="mailto:luobo2028@163.com">luobo2028@163.com</a>
              ）开发和运营。本应用尊重并保护所有用户的个人隐私。为帮助你了解本应用如何收集、使用和保护你的个人信息，请仔细阅读本隐私政策。完整隐私政策也可访问：
              <a href="https://openwu.cn/privacy" target="_blank" rel="noreferrer">
                https://openwu.cn/privacy
              </a>
            </p>
          </section>

          <section className="privacy-section">
            <h2>一、我们收集和使用的信息</h2>
            <p>
              为了提供水印相机核心功能（包括拍照、添加水印、保存照片），本应用会收集并使用以下信息：
            </p>

            <ul>
              <li>
                <strong>位置权限</strong>
                <ul>
                  <li>
                    <strong>用途：</strong>
                    使用设备的定位功能获取经纬度和地理位置，用于在水印中显示拍摄地点。
                  </li>
                  <li>
                    <strong>数据处理：</strong>
                    位置信息仅在本地处理，不会上传至任何服务器。
                  </li>
                  <li>
                    <strong>关闭影响：</strong>
                    关闭位置权限可能导致位置水印无法使用。
                  </li>
                </ul>
              </li>

              <li>
                <strong>相机权限</strong>
                <ul>
                  <li>
                    <strong>用途：</strong>
                    访问相机拍摄照片，提供实时预览画面。
                  </li>
                  <li>
                    <strong>数据处理：</strong>
                    照片数据仅在本地处理，不会上传至任何服务器。
                  </li>
                </ul>
              </li>

              <li>
                <strong>相册权限</strong>
                <ul>
                  <li>
                    <strong>用途：</strong>
                    保存拍摄的照片到相册，读取相册中的照片进行编辑。
                  </li>
                  <li>
                    <strong>数据处理：</strong>
                    照片数据仅在本地处理，不会上传至任何服务器。
                  </li>
                </ul>
              </li>

              <li>
                <strong>传感器信息（重力传感器、加速度传感器、磁场传感器）</strong>
                <ul>
                  <li>
                    <strong>收集方式：</strong>
                    在你使用拍摄及指南针相关功能时，本应用通过设备系统传感器接口实时读取传感器数据，具体包括：
                    <ul>
                      <li>
                        <strong>重力传感器：</strong>
                        识别设备握持方向（横屏/竖屏），用于判断拍摄方向、水印横竖版排版以及水平仪辅助；
                      </li>
                      <li>
                        <strong>加速度传感器：</strong>
                        在你按下快门拍照时读取一次设备加速度数据，计算拍摄角度以确定照片保存方向；在你使用指南针功能时，配合磁场传感器进行倾斜补偿，提高方位计算准确度；
                      </li>
                      <li>
                        <strong>磁场传感器：</strong>
                        使用指南针相关水印功能时读取地磁场数据，计算设备当前朝向的方位角。
                      </li>
                    </ul>
                  </li>
                  <li>
                    <strong>使用目的：</strong>
                    用于照片方向识别与横竖版排版、水平仪和指南针水印显示，不用于用户画像或其他用途。
                  </li>
                  <li>
                    <strong>使用范围：</strong>
                    传感器数据仅在功能使用期间于设备本地实时计算，本应用不会保存原始传感器数据，不会形成用户画像，也不会上传至任何服务器。
                  </li>
                  <li>
                    <strong>权限控制：</strong>
                    上述传感器在你同意本隐私政策后方可启动，你可通过系统设置中的“获取应用设备方向”开关或本应用设置页随时关闭；关闭后不影响基础拍照，但水平仪、指南针及拍摄方向自动识别功能将无法使用。
                  </li>
                </ul>
              </li>

              <li>
                <strong>其他信息</strong>
                <ul>
                  <li>
                    <strong>时间信息：</strong>
                    获取设备系统时间，用于在水印中显示拍摄时间。
                  </li>
                </ul>
              </li>

              <li>
                <strong>华为账号信息</strong>
                <ul>
                  <li>
                    <strong>用途：</strong>
                    当你使用会员相关功能（包括扫描、记录生活拍照模式）时，本应用会引导你登录华为账号，用于识别用户身份、管理会员权益、绑定购买记录以及支持跨设备恢复购买。
                  </li>
                  <li>
                    <strong>收集的信息：</strong>
                    通过华为账号服务获取你的 OpenID、UnionID、授权码等匿名标识信息；若你授权 profile 范围，可能还会获取昵称、头像等公开资料。
                  </li>
                  <li>
                    <strong>数据处理：</strong>
                    华为账号认证由华为账号服务（Account Kit）处理，本应用仅在设备本地保存登录状态，不会将你的华为账号信息上传至开发者服务器。
                  </li>
                  <li>
                    <strong>关闭影响：</strong>
                    不登录华为账号将无法使用会员相关功能，但基础拍照和水印功能仍可正常使用。
                  </li>
                </ul>
              </li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>二、信息的存储与保护</h2>
            <ul>
              <li>
                <strong>本地数据：</strong>
                你拍摄的照片、照片附带的水印信息（包括时间、地点等）以及你的位置数据，均主要存储在你的设备本地。我们不会主动收集、上传或备份你的照片到我们的服务器。
              </li>
              <li>
                <strong>技术措施：</strong>
                我们采取合理的技术措施保护你的个人信息安全，包括对本地数据进行访问权限控制、避免非必要的数据外传，以及防止数据被未经授权的访问、泄露、篡改或丢失。
              </li>
              <li>
                <strong>第三方限制：</strong>
                我们不会将你的个人信息出售、出租或以其他方式提供给任何第三方，除非：
                <ul>
                  <li>（a）获得你的明确同意；</li>
                  <li>（b）根据法律法规要求；</li>
                  <li>（c）为维护合法权益所必需。</li>
                </ul>
              </li>
              <li>
                <strong>你的控制权：</strong>
                你可以随时在系统设置中关闭位置、相机、相册等权限，或删除本应用以清除所有本地存储的数据。关闭位置权限可能导致位置水印无法使用。
              </li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>三、第三方服务</h2>
            <ul>
              <li>
                <strong>华为账号服务：</strong>
                用于登录、识别用户身份、管理会员权益和恢复购买。
              </li>
              <li>
                <strong>华为应用内支付服务：</strong>
                用于会员商品购买、订阅状态同步和购买记录恢复。
              </li>
              <li>
                <strong>数据处理：</strong>
                账号认证与支付流程由华为相关服务处理，具体信息处理规则请阅读华为对应的隐私政策与服务协议。
              </li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>四、你的权利</h2>
            <ul>
              <li>
                <strong>权限管理：</strong>
                你可以随时在系统设置中关闭相机、位置、相册、传感器等权限。关闭权限后，相关功能可能无法使用。
              </li>
              <li>
                <strong>数据清除：</strong>
                你可以删除本应用以清除所有本地存储的数据。
              </li>
              <li>
                <strong>咨询反馈：</strong>
                如果你对我们的个人信息处理有任何疑问，可以通过本页面底部提供的联系方式与我们联系。
              </li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>五、未成年人保护</h2>
            <p>我们非常重视未成年人的个人信息保护。</p>
            <p>如果你是未成年人，请在监护人指导下使用本应用。</p>
          </section>

          <section className="privacy-section">
            <h2>六、政策更新</h2>
            <p>我们可能会根据法律法规和业务发展需要不时更新本隐私政策。</p>
            <p>更新后的政策将在应用内公示，请定期查看。</p>
            <p>如果你继续使用本应用，即视为同意更新后的政策。</p>
          </section>

          <section className="privacy-section">
            <h2>七、联系我们</h2>
            <p>如果你对本隐私政策有任何疑问、意见或建议，请通过以下方式与我们联系：</p>
            <ul>
              <li>
                <strong>邮箱：</strong>
                <a href="mailto:luobo2028@163.com">luobo2028@163.com</a>
              </li>
              <li>
                <strong>隐私政策链接：</strong>
                <a href="https://openwu.cn/privacy" target="_blank" rel="noreferrer">
                  https://openwu.cn/privacy
                </a>
              </li>
            </ul>
          </section>
        </main>

        <footer className="privacy-footer">
          <Link to="/" className="back-home-link">回到首页</Link>
          <p className="copyright">© 2026 萝卜水印相机</p>
        </footer>
      </div>
    </div>
  )
}

export default PrivacyPage
